<div class="bulkmail">
  <h2>Subscribe to Bulkmail</h2>
  <div>OTA bulkmail will keep you in the know on new feature updates and alert you when system outages occur.</div>
  <a href="https://www.bulkmailex.ford.com/selfJoin/MMOTA%20Communication" target="_blank" rel="noopener noreferrer">
    <ota-secondary-button [label]="'Subscribe'" (click)="subscribeClick()"></ota-secondary-button>
  </a>

</div>
